import { Injectable } from '@angular/core';
import { GlobalVariable } from '.././config/service.config';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ContratoecertService {

  url = GlobalVariable.BASE_API_URL; //
  urla = GlobalVariable.API_Admision;
  token = `Bearer ${JSON.parse(localStorage.getItem('token'))}`;
  headersc = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json');

  headers = new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization: this.token.replace(/["']/g, '')
  });

  constructor(private http: HttpClient) { }

  getMetodoFirma() : any {
    debugger;
    return this.http.post(
      `${this.urla}ServicioECert/RetornaMetodoFirma`,
      null,
      {
        headers: this.headersc
      });
  }

  getTrazabilidadFirmaECert(idpreoceso:string){
    debugger;
    return this.http.post(`${this.urla}ServicioECert/TrazabilidadFirmaECert/?idProceso=${idpreoceso}`, null, { headers: this.headersc });
  }

  PreinscribirECert(idpreoceso:string, portalName:string){
    debugger;
    return this.http.post(`${this.urla}ServicioECert/PreinscribirECert/?idProceso=${idpreoceso}&redirectPotal=${portalName}`, null, { headers: this.headersc });
  }

  getUSTFirmaDocumentoTRX(idpreoceso:string){
    debugger;
    return this.http.post(`${this.urla}ServicioECert/getUSTFirmaDocumentoTRX/?idProceso=${idpreoceso}`, null, { headers: this.headersc });
  }

  getContratoUST(idpreoceso:string){
    debugger;
    return this.http.post(`${this.urla}ServicioECert/getContratoUST/?idProceso=${idpreoceso}`, null, { headers: this.headersc });
  }
  
  SubirDocumentoECert(idpreoceso:string){
    debugger;
    return this.http.post(`${this.urla}ServicioECert/SubirDocumentoECert/?idProceso=${idpreoceso}`, null, { headers: this.headersc });
  }

  VisualizarContrato(idpreoceso:string){
    debugger;
    return this.http.post(`${this.urla}ServicioECert/VisualizarContrato/?idProceso=${idpreoceso}`, null, { headers: this.headersc });
  }

  CaducarPreinscripcionECert(idpreoceso:string){
    debugger;
    return this.http.post(`${this.urla}ServicioECert/CaducarPreinscripcionECert/?idProceso=${idpreoceso}`, null, { headers: this.headersc });
  }

  RedireccionarECert(idpreoceso:string){
    debugger;
    return this.http.post(`${this.urla}ServicioECert/RedireccionarECert/?idProceso=${idpreoceso}`, null, { headers: this.headersc });
  }

  EnviarContrato(idpreoceso:string){
    debugger;
    return this.http.post(`${this.urla}ServicioECert/EnviarContrato/?idProceso=${idpreoceso}`, null, { headers: this.headersc });
  }
}
